import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
  padding: ${props => props.theme.spacing.sp24} 0;
`

export const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
export const MessageSectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props =>
    props.aiMode ? props.theme.colors.ai.surface : props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  transition: background-color 0.3s ease;
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
